import React from 'react';
import api from 'controllers/raymanAPI';
import Singletons from 'controllers/Singletons';

async function getData()
{
    let indexed = {};
    let profiles = {operators: [], experts: [], admins: []};
    let data = [];
    let activeCount = 0;
    let response = await api.users.getAll();
    let tmpData = await response.json();

    tmpData.forEach(item => {
        item.id = item.userID;
        item.avatarSrc = api.internalApi.GetApiURL(["users", item.userID, "avatar"]);
        data.push(item);
        indexed[item.userID] = item;
        if(!item.disabled) activeCount++;
        if(item.profiles.indexOf("operators") > -1 && !item.disabled)
        {
            profiles.operators.push(item);
        }
        if(item.profiles.indexOf("experts") > -1 && !item.disabled)
        {
            profiles.experts.push(item);
        }
        if(item.profiles.indexOf("administrators") > -1 && !item.disabled)
        {
            profiles.admins.push(item);
        }

        if(item.userID === Singletons.currentUser.userID)
        {
            item.state = Singletons.currentUser.state;
        }
    });
    
    return {array: data, indexed: indexed, profiles: profiles, activeCount: activeCount};
}

const UsersCtx = React.createContext({
    loading: true, 
    data: {
        array: [], 
        indexed: {},
        profiles: {operators: [], experts: [], admins: []},
        activeCount: 0
    }, 
    funcs: {
        create: async (data)=>{},
        disable: async (userID)=>{},
        enable: async (userID)=>{},
        update: async (userID, data)=>{},
        updateProfiles: async (userID, profileChanges)=>{},
        setAvatar: (userID, value) => {}
    }
});

function UsersCtxProvider(props)
{

    const [loading, setLoading] = React.useState(true);
    const [data, setData] = React.useState({array: [], indexed: [], profiles: {operators: [], experts: [], admins: []}, activeCount: 0});

    React.useEffect(() => {
        getData().then(values => {
            setData(values);
            setLoading(false);
        });
    }, []);

    const internalUpdate = React.useCallback((userID, userData) => {
        if(data.indexed[userID] === undefined) return;
        let tmp = {...data};
        userData = {...tmp.indexed[userID], ...userData};
        
        Object.keys(userData).forEach((key) => {
            tmp.indexed[userID][key] = userData[key];
            if(key === "profiles" || (key === "disabled" && userData.disabled === true))
            {
                // remove the user from profile lists
                let profileIndex = tmp.profiles.operators.indexOf(tmp.indexed[userID]);
                if(profileIndex > -1) tmp.profiles.operators.splice(profileIndex,1);
                profileIndex = tmp.profiles.experts.indexOf(tmp.indexed[userID]);
                if(profileIndex > -1) tmp.profiles.experts.splice(profileIndex,1);
                profileIndex = tmp.profiles.admins.indexOf(tmp.indexed[userID]);
                if(profileIndex > -1) tmp.profiles.admins.splice(profileIndex,1);
            }
            if((key === "profiles" || key === "disabled") && !userData.disabled)
            {
                if(userData.profiles.indexOf("operators") > -1 && tmp.profiles.operators.indexOf(tmp.indexed[userID]) === -1) tmp.profiles.operators.push(tmp.indexed[userID]);
                if(userData.profiles.indexOf("experts") > -1 && tmp.profiles.experts.indexOf(tmp.indexed[userID]) === -1) tmp.profiles.experts.push(tmp.indexed[userID]);
                if(userData.profiles.indexOf("administrators") > -1 && tmp.profiles.admins.indexOf(tmp.indexed[userID]) === -1) tmp.profiles.admins.push(tmp.indexed[userID]);
            }
        })
        let count = 0;
        tmp.array.forEach((user) => {if(!user.disabled) count++;});
        tmp.activeCount = count;
        setData(tmp);
    }, [data]);

    const internalAdd = React.useCallback(async (userID, item) => {
        if(data.indexed[userID] !== undefined)
        {
            return internalUpdate(userID, item);
        }
        let tmp = {...data};
        //let result = await api.users.getSingle(userID);
        //if(result.ok)
        {
            //let item = await result.json();
            item.id = item.userID;
            let index = tmp.array.push(item);
            tmp.indexed[item.id] = tmp.array[index-1];
            if(!item.disabled) tmp.activeCount++;
            if(item.profiles.indexOf("operators") > -1 && !item.disabled) tmp.profiles.operators.push(item);
            if(item.profiles.indexOf("experts") > -1 && !item.disabled) tmp.profiles.experts.push(item);
            if(item.profiles.indexOf("administrators" && !item.disabled) > -1) tmp.profiles.admins.push(item);
            setData(tmp);
        }
    }, [data, internalUpdate]);


    const create = React.useCallback(async (data) => {
        let result = await api.users.post(data);
        
        if(result.ok)
        {
            let created = await result.json();
            await internalAdd(created.userID, created);
            return created;
        }
        else return null;
    }, [internalAdd]);

    const update = React.useCallback(async (userID, data) => {
        let result = await api.users.updateSingle(userID, data);
        if(result.ok)
        {
            internalUpdate(userID, data);
            return await result.json();
        }
        else return null;
    }, [internalUpdate]);

    const disable = React.useCallback(async (userID) => {
        let result = await api.users.disable(userID);
        if(result.ok)
        {
            internalUpdate(userID, {disabled: true});
        }
    }, [internalUpdate]);

    const enable = React.useCallback(async (userID) => {
        let result = await api.users.enable(userID);
        if(result.ok)
        {
            internalUpdate(userID, {disabled: false});
        }
    }, [internalUpdate]);

    const updateProfiles = React.useCallback(async (userID, profileChanges) => {
        if(!userID || !profileChanges) return;

        let profiles = [...data.indexed[userID].profiles];
        for(let i = 0; i < profileChanges.add.length; i++)
        {
            await api.profiles.putProfileUsers(profileChanges.add[i], [userID]);
            profiles.push(profileChanges.add[i]);
        }

        for(let i = 0; i < profileChanges.remove.length; i++)
        {
            await api.profiles.deleteProfileUsers(profileChanges.remove[i], [userID]);
            profiles.splice(profiles.indexOf(profileChanges.remove[i]), 1);
        }
        internalUpdate(userID, {profiles: profiles});
    }, [internalUpdate, data.indexed]);

    const setAvatar = React.useCallback((userID, state) => {
        if(!data.indexed[userID]) return;
        let tmp = {...data};
        tmp.indexed[userID].avatar = state;
        if(state) tmp.indexed[userID].avatarSrc = api.internalApi.GetApiURL(["users", userID, "avatar"]) + "?"+Math.random();
        setData(tmp);
    }, [data]);

    React.useEffect( function handleNotifications() {

        const handleCreate = (message) => internalAdd(message.userID, message);
        const handleEnable = (message) => internalUpdate(message.userID, {disabled: false});
        const handleDisable = (message) => internalUpdate(message.userID, {disabled: true});
        const handleUpdate = (message) => internalUpdate(message.userID, message);
        const handleStateUpdate = (message) => internalUpdate(message.userID, {state: message.state});
        const handleCurrentUserConnected = () => internalUpdate(Singletons.currentUser.userID, {state: "available"});
        const handleCurrentUserDisconnected = () => internalUpdate(Singletons.currentUser.userID, {state: "disconnected"});
        const updateAvatar = (message) => setAvatar(message.userID, true);
        const deleteAvatar = (message) => setAvatar(message.userID, false);

        Singletons.NotificationsSocket.on('users.created', handleCreate);
        Singletons.NotificationsSocket.on('users.disabled', handleDisable);
        Singletons.NotificationsSocket.on('users.enabled', handleEnable);
        Singletons.NotificationsSocket.on('users.updated', handleUpdate);
        Singletons.NotificationsSocket.on('users.state.updated', handleStateUpdate);
        Singletons.NotificationsSocket.on('users.avatar.updated', updateAvatar);
        Singletons.NotificationsSocket.on('users.avatar.deleted', deleteAvatar);
        Singletons.NotificationsSocket.on('socketConnected', handleCurrentUserConnected);
        Singletons.NotificationsSocket.on('socketDisconnected', handleCurrentUserDisconnected);

        return () => {
            Singletons.NotificationsSocket.off('users.created', handleCreate);
            Singletons.NotificationsSocket.off('users.disabled', handleDisable);
            Singletons.NotificationsSocket.off('users.enabled', handleEnable);
            Singletons.NotificationsSocket.off('users.updated', handleUpdate);
            Singletons.NotificationsSocket.off('users.state.updated', handleStateUpdate);
            Singletons.NotificationsSocket.off('users.avatar.updated', updateAvatar);
            Singletons.NotificationsSocket.off('users.avatar.deleted', deleteAvatar);
            Singletons.NotificationsSocket.off('socketConnected', handleCurrentUserConnected);
            Singletons.NotificationsSocket.off('socketDisconnected', handleCurrentUserDisconnected);
        }

    }, [internalAdd, internalUpdate, setAvatar]);

    return <UsersCtx.Provider value={{loading: loading, data: {...data}, funcs: {create: create, update: update, disable: disable, enable: enable, updateProfiles: updateProfiles, setAvatar: setAvatar}}} >
        {props.children}
        </UsersCtx.Provider>
}

export {UsersCtx, UsersCtxProvider};
